import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoStatus from './ContentSolicitacaoFluxoStatus';

const SolicitacaoFluxoStatus = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSolicitacaoFluxoStatus />
      <Bottom />
    </div>
  );
};

export default SolicitacaoFluxoStatus;
